import createId from "create-id"
import { WATTS, AMPS, VOLTS } from '../props-types.js'
import { COLUMS, LINES } from '../props-types.js'
import { LINE1, LINE2, LINE3 } from '../props-types.js'
import { CHART } from '../props-types.js'

class Chart{

    constructor(chart){
        this.id = chart.id ? chart.id : createId()
        this.name = chart.name ? chart.name : ''
        this.lines = chart.lines ? chart.lines : [ LINE1 ]
        this.period = chart.period ? chart.period : 1
        this.props = chart.props ? chart.props : [ WATTS, AMPS, VOLTS ]
        this.type = chart.type ? chart.type : LINES
        this.graph = CHART
    }

    get(){
        return {
            id: this.id,
            name: this.name,
            lines: this.lines,
            period: this.period,
            props: this.props,
            type: this.type
        }
    }

    setName(name){
        this.name = name
    }

    setType(type){
        if(type !== COLUMS && type !== LINES) return false
        this.type = type
    }

    addLine(line){
        if(line !== LINE1 || line !== LINE2 || line !== LINE3) return false
        if(this.lines.find( l => l === line )) return

        this.lines.push(lines) 
    }

    removeLine(line){
        let index = this.lines.find( l => l === line )
        if(index < 0) return

        this.lines.splice(index, 1)
    }

    addProp(prop){
        if(prop !== WATTS || prop !== AMPS || prop !== VOLTS) return false
        if(this.props.find( p => p === prop )) return

        this.props.push(lines) 
    }

    removeProp(prop){
        let index = this.lines.find( p => p === prop )
        if(index < 0) return

        this.lines.splice(index, 1)
    }

    setPeriod(period){
        this.period = period
    }

}

export default Chart